import {postRequest}  from "./requestType";
const regList = {
    //  手机号段， 11位
      phone : /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
      name: /^([a-zA-Z0-9\u4e00-\u9fa5\·]{1,10})$/,
      identification: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
      code:/^\d{6}$/,
      desc:/^\d+$/ 
  }

  export const checkName = (rule, value, callback) =>{
    if (!value) {
      return callback(new Error('姓名不能为空'));
    }
    setTimeout(() => {
      if (!regList.name.test(value)) {
        callback(new Error('姓名输入有误'));
      } else {
        callback();
      }
    }, 1000);
  }


  export  const checkStudentId = (rule, value, callback) =>{
    if (!value) {
      return callback(new Error('学工号不能为空'));
    }else{
      callback();
    }
  }
  export const checkCode = (rule, value, callback) =>{
    if (!value) {
      return callback(new Error('验证码不能为空'));
    }
    //setTimeout(() => {
      if (!regList.code.test(value)) {
        callback(new Error('验证码输入有误'));
      } else {
        callback();
      }
    //}, 1000);
  }

  export const checkDesc = (rule, value, callback) =>{
    if (!value) {
      return callback(new Error('问题描述不能为空'));
    }
    setTimeout(() => {
        callback();
    }, 1000);
  }





// WEBPACK FOOTER //
// ./src/config/formCheck.js